import Utils from './Utils';

const ALPHAS: Array<[string, number]> = [
  ['10', 0.1],
  ['20', 0.2],
  ['30', 0.3],
  ['40', 0.4],
  ['80', 0.8],
];

/**
 * Writes the --primary* / --primary*-dark custom properties from the tenant color.
 *
 * In dark mode the base colour is lightened so it keeps enough contrast against
 * the dark background — same approach Skytalent uses.
 */
export function applyPrimaryPalette(color?: string) {
  const root = document.documentElement.style;

  const light = Utils.normalizeHex(color);
  const dark = Utils.lightenColor(light, 100);

  root.setProperty('--primary', light);
  ALPHAS.forEach(([suffix, alpha]) => {
    root.setProperty(`--primary${suffix}`, Utils.rgbaFromHex(light, alpha));
  });

  root.setProperty('--primary-dark', dark);
  ALPHAS.forEach(([suffix, alpha]) => {
    root.setProperty(`--primary${suffix}-dark`, Utils.rgbaFromHex(dark, alpha));
  });
}

/** The colour antd should use as colorPrimary for the current theme. */
export function resolvePrimary(color: string | undefined, isDark: boolean) {
  const light = Utils.normalizeHex(color);
  return isDark ? Utils.lightenColor(light, 100) : light;
}
